<template>
  <div id="certificationInfoRef">
    <div class="top_line">
        <span class="mainName">{{dataObj.chapter1?dataObj.chapter1.baseInfo.mainName:'--'}}</span>
      </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>证书/资质证书情况</span>
      </div>
      <div class="card-content">
        <el-table
          border
          :data="tableList"
          align="center"
          style="width: 100%"
          ref="table"
          :header-cell-style="headerCellStyle"
          :row-key="getRowKeys"
        >
          <el-table-column label="序号" type="index" align="center" width="50">
            <template scope="scope">
              <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column label="证书类别" align="center" width="120" prop="qualificationTypeName">
            <template scope="scope">
              <p>{{scope.row.qualificationTypeName || "--"}}</p>
            </template>
          </el-table-column>
          <el-table-column label="证书编号" align="center" :show-overflow-tooltip="true" prop="certNo">
            <template scope="scope">
              <p>{{scope.row.certNo || "--"}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="证书名称"
            align="center"
            :show-overflow-tooltip="true"
            prop="certName"
          >
            <template scope="scope">
              <p>{{scope.row.certName || "--"}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="证书有效期至"
            align="center"
            width="110"
            prop="qualificationValidityEnd"
          >
            <template scope="scope">
              <p>{{scope.row.qualificationValidityEnd | dateStrIntercept}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="资质名称"
            align="center"
            :show-overflow-tooltip="true"
            prop="qualificationName"
          >
            <template scope="scope">
              <p>{{scope.row.qualificationName || "--"}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="数据来源"
            align="center"
            :show-overflow-tooltip="true"
            width="100"
            prop="dataSource"
          ></el-table-column>
          <el-table-column label="数据状态" align="center" width="120" prop="dataState">
            <template scope="scope">
              <p type="text" class="change-examine">
                <i :class="formatDataState(scope.row.dataState,'class')"></i>
                <span>{{scope.row.dataStateName}}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column
            label="登记日期"
            width="90"
            align="center"
            :show-overflow-tooltip="true"
            prop="createTime"
          >
            <template scope="scope">
              <p>{{scope.row.createTime?formatDate(scope.row.createTime,"yyyy-MM-dd"):'--'}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="作废日期"
            align="center"
            :show-overflow-tooltip="true"
            width="90"
            prop="cancelTime"
          >
            <template scope="scope">
              <p>{{scope.row.cancelTime?formatDate(scope.row.cancelTime,"yyyy-MM-dd"):'--'}}</p>
            </template>
          </el-table-column>

          <el-table-column type="expand" width="1">
            <template slot-scope="props">
              <formDetail
                :rowId="props.row.id"
                :rowData="props.row"
                :editFlag.sync="editFlag"
                @saveSuccess="formSaveSuccess"
                @formCancel="formCancel"
              />
              <span
                @click="toogleExpandFalse(props.row)"
                style="position: absolute; bottom: 16px; right: 17px; font-weight: 400; color: #1890FF; font-size: 14px; cursor: pointer;"
              >
                收起
                <i class="el-icon-arrow-up" style="color: #1890FF;margin-left: 4px;"></i>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination> -->
      <el-form
        :model="certificateForm"
        ref="certificateRef"
        label-width="140px"
        v-loading="loadingFlag"
        style="position: relative;margin-top:20px;"
      >
        <el-row>
          <el-col>
            <el-form-item
              v-for="(item,index) in (this.dataObj&&this.dataObj.chapter3?this.dataObj.chapter3.attachmentList:[])"
              :label="item.remark?(item.remark+'：'):'附件：'"
              :key="index"
            >
              <imgUploadView
                :backgroundType="5"
                :fileName.sync="item.name"
                :imgUrl.sync="item.filePath"
                :styleConfig="{width:'700px',height:'400px'}"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getUUID } from "@/utils/index";
export default {
  props: {
    dataObj: {
      type: Object,
      default: () => {}
    },
    attachments: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loadingFlag: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableList: [],
      headerCellStyle: {
        "background-color": "#EFF3F6",
        "font-size": "14px",
        color: "#000000"
      },
      editFlag: false,
      pageStatus: "view",
      entStatus: "", //-1:待提交;0:待审核/核验中;1:正常;2:暂停;3:部分暂停;4:核验不通过;5:正常(有变更待提交);6:正常(有变更核验中);7:正常(有变更核验不通过);
      certificateForm: {
        attachments: [] // 附件列表
      },
      ent_cert_attachments: []
    };
  },
  watch: {
    dataObj: {
      deep: true,
      immediate: true,
      handler(val) {
        this.tableList = val.chapter3 ? val.chapter3.certList : [];
        this.total = this.tableList.length;
      }
    },
    attachments: {
      deep: true,
      immediate: true,
      handler(val) {
        this.ent_cert_attachments = val ? val.ent_emp_cert_att : [];
      }
    }
  },
  filters: {
    dateStrIntercept(str) {
      if (str && str.length > 0) {
        return str.substring(0, 10);
      } else {
        return "--";
      }
    }
  },
  computed: {
    ...mapState({
      isAdmin: state => state.user.userPermStr == "admin"
    })
  },
  methods: {
    getRowKeys(row) {
      return row.id;
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.queryData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryData();
    }
  }
};
</script>

<style lang="scss" scoped>
  #certificationInfoRef{
    border: 1px solid #d8d8d8;
    .top_line {
      width: 80%;
      height: 50px;
      color: #8a8a8a;
      margin: 0 auto;
      border-bottom: 1px solid #d8d8d8;
      position: relative;
      .mainName {
        position: absolute;
        bottom: 10px;
        right: 0;
      }
    }

  }
</style>